import React from 'react';
import { styled } from '@linaria/react';
import { Alert } from '@daedalus/atlas/Alert';
import { Button } from '@daedalus/atlas/Button';
import { CookieIcon } from '@daedalus/atlas/foundation/illustrations/CookieIcon';
import { NoStyleLink } from '@daedalus/atlas/helpers/NoStyleLink';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { CookieBannerClickComponent } from './useCookieConsent';
const CookieBannerWrapper = /*#__PURE__*/styled('div')({
  name: "CookieBannerWrapper",
  class: "ct0vaex",
  propsAsIs: false
});
const TitleWrapper = /*#__PURE__*/styled('div')({
  name: "TitleWrapper",
  class: "tj0sg18",
  propsAsIs: false
});
const CookieIconWrapper = /*#__PURE__*/styled('div')({
  name: "CookieIconWrapper",
  class: "c9ejugp",
  propsAsIs: false
});
const BodyWrapper = /*#__PURE__*/styled('div')({
  name: "BodyWrapper",
  class: "btp69nx",
  propsAsIs: false
});
const SubTitleWrapper = /*#__PURE__*/styled('div')({
  name: "SubTitleWrapper",
  class: "sss3g4p",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => Text;
const SubTitle = /*#__PURE__*/styled(_exp6())({
  name: "SubTitle",
  class: "s1v5vp87",
  propsAsIs: true
});
const _exp10 = /*#__PURE__*/() => NoStyleLink;
const SettingsLink = /*#__PURE__*/styled(_exp10())({
  name: "SettingsLink",
  class: "s1ddrcw9",
  propsAsIs: true
});
const ButtonContainer = /*#__PURE__*/styled('div')({
  name: "ButtonContainer",
  class: "b12ulxl1",
  propsAsIs: false
});
const _exp14 = /*#__PURE__*/() => Button;
const ActionButton = /*#__PURE__*/styled(_exp14())({
  name: "ActionButton",
  class: "a11v3urf",
  propsAsIs: true
});
const _exp16 = /*#__PURE__*/() => Alert;
const StyledAlertBannerFullWidth = /*#__PURE__*/styled(_exp16())({
  name: "StyledAlertBannerFullWidth",
  class: "s7dyl5v",
  propsAsIs: true
});
interface Props {
  acceptAllCookies: () => void;
  openPreferencesCenter: () => void;
  rejectAllCookies: (component?: CookieBannerClickComponent) => void;
}
const CookieConsentBannerComponent = ({
  acceptAllCookies,
  openPreferencesCenter,
  rejectAllCookies
}: Props) => {
  return <StyledAlertBannerFullWidth onClose={rejectAllCookies} title={<TitleWrapper>
          <CookieIconWrapper>
            <CookieIcon />
          </CookieIconWrapper>
          <Text variant="labelM">
            <FormattedMessageWrapper id="cookieProBannerTitle" defaultMessage="We use cookies" />
          </Text>
        </TitleWrapper>}>
      <CookieBannerWrapper>
        <BodyWrapper>
          <SubTitleWrapper>
            <SubTitle>
              <FormattedMessageWrapper id="cookieProBannerMessage" defaultMessage="We use cookies to give you the best experience on our website and also for analytics purposes." />{' '}
              <SettingsLink onClick={openPreferencesCenter}>
                <FormattedMessageWrapper id="cookieProBannerSettingsLink" defaultMessage="Learn more and adjust settings." />
              </SettingsLink>
            </SubTitle>
          </SubTitleWrapper>

          <ButtonContainer>
            <ActionButton fullWidth iconStart={<Icon name="Checkmark" size="md" />} dataId="acceptAllCookiesButton" size="lg" variant="secondary" onClick={acceptAllCookies}>
              <FormattedMessageWrapper id="acceptAllCookiesButton" defaultMessage="Accept" />
            </ActionButton>
            <ActionButton fullWidth iconStart={<Icon name="Close" size="md" />} dataId="rejectAllCookiesButton" size="lg" variant="secondary" onClick={() => rejectAllCookies(CookieBannerClickComponent.RejectButton)}>
              <FormattedMessageWrapper id="rejectAllCookiesButton" defaultMessage="Reject" />
            </ActionButton>
          </ButtonContainer>
        </BodyWrapper>
      </CookieBannerWrapper>
    </StyledAlertBannerFullWidth>;
};
export const CookieConsentBanner = React.memo(CookieConsentBannerComponent);

require("./CookieConsentBanner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CookieConsentBanner.tsx");